import { FC } from 'react'

import styles from './Main.pcss'

const Main: FC = ({ children }) => (
	<main className={styles.main}>{children}</main>
)

export default Main
